import { OnInit, Component } from '@angular/core'
import Swal from 'sweetalert2'
import { StateService } from '../../services/state.service';
import { RepositorioApiService } from '../../api/repositorio-api.service';
import { formatRelative, subDays } from 'date-fns';

import { es } from 'date-fns/locale'
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-user-masive',
  templateUrl: './user-masive.component.html',
  styleUrls: ['./user-masive.component.css']
})
export class UserMasiveComponent implements OnInit {

  file:any
  documentos:any
  loading:boolean = false
  constructor(
    public state:StateService,
    private repositoryService:RepositorioApiService,
    private translate:TranslateService
  ) { }
  
  ngOnInit() {
  
 this.obtenerpermisos()
  }

  async obtenerpermisos(){
    let data=await this.repositoryService.obtenertablapermisos()
    data.subscribe(data=>{
      this.documentos=data
    })
  }


  uploadImage(e){

    if(e.target.files && e.target.files.length > 0){
       this.file = e.target.files[0]
       document.getElementById('file-name').innerHTML=e.target.files[0].name
   
    }
  }

  getFormat(date){
    return formatRelative(subDays(new Date(date), 3), new Date(), { locale:es })
  }


  saveImage(){
    
    const file:any = document.getElementById('file')
   
    if(file.value == ""){ 
      return Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: this.translate.instant('seleccione un archivo'),
      })
    }

    let tipo = file.files[0].name.split(".")[1]
    
    if(tipo != "xlsx"){
      return Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: this.translate.instant('Solo permite formato xlsx'),
      })
    }
 
    if(file.files[0].size >10000000){
      return Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: this.translate.instant('El tamaño del archivo supera los 10mb'),
      })
    }

    if(this.file == null){
      return Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: this.translate.instant('seleccione un archivo'),
      })
    }

    this.loading= true 
    const formdata:FormData = new FormData()
    const username = this.state.getValueOf('user').name
    const documento=this.state.getValueOf('user').sub
    formdata.append('image',this.file )
    formdata.append('username',username )
    formdata.append('documento',documento)
   
    this.repositoryService.creartablapermisos(formdata).subscribe(
      (res:any)=>{
         
          Swal.fire({
            icon:'success',
            title: res.message,
            showConfirmButton: false,
            timer: 1500
     
          })
           const file:any = document.getElementById('file')
           file.value=null
          document.getElementById('file-name').innerHTML=this.translate.instant('Selecicone o arrastre el archivo')
          this.obtenerpermisos()
          this.loading= false 
        },
        err=>{
          
        }
      )

   return
  }


}
